export enum FilterOrderTab {
  SERVICE_POINTS = 1,
  CENTERS,
  ENTITIES,
}
